var React = require('react');

function ArrowNext (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","fill":"#F9F7F7","r":"16","key":0}),React.createElement("g",{"stroke":"#000","strokeWidth":"1.2","key":1},[React.createElement("path",{"d":"m9.35325 15.8585h13.57645","key":0}),React.createElement("path",{"d":"m17.2728 10.2017 5.6569 5.6568-5.6569 5.6569","key":1})])]);
}

ArrowNext.defaultProps = {"fill":"none","height":"32","viewBox":"0 0 32 32","width":"32"};

module.exports = ArrowNext;

ArrowNext.default = ArrowNext;
